import type { DropdownItem } from '@ibsys/kit';
import type { LucideIcon } from 'lucide-react';
import { openUrlInNewTab } from '@/shared/lib';
import type { BrokenContentImage } from '../model/htmlContent';

/** Пункты меню не загрузившихся картинок — значок группы и имя картинки; пункт открывает её в новой вкладке. */
export const getBrokenImageMenuItems = (images: BrokenContentImage[], Icon: LucideIcon): DropdownItem[] =>
  images.map((image) => ({
    type: 'item',
    key: image.key,
    title: (
      <span className="flex min-w-0 items-center gap-2">
        <Icon className="size-3.5 shrink-0 text-muted-foreground" />
        <span className="truncate">{image.name}</span>
      </span>
    ),
    onClick: () => openUrlInNewTab(image.src),
  }));
